export enum SaveState {
    Unchainged,
    IngestionProcessStaredMessage,
    SaveSucceeded,
    SaveFailed,
    Cancelled,
    Refresh
}